
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.268 0a.657.657 0 00-.08.008l.004-.001h-5.633a.714.714 0 100 1.429H17.557L13.064 5.93a.715.715 0 001.01 1.01l4.493-4.494V6.444a.714.714 0 101.43 0V.81A.714.714 0 0019.288 0h-.022.002-.001zM.704 12.852a.715.715 0 00-.704.714v5.727l.003.06v-.002.011-.002l.008.058v-.005c0 .011.002.018.004.024v-.004a.72.72 0 00.067.187l-.002-.004.011.02-.001-.004c.01.019.02.034.03.049l-.002-.003.011.017-.002-.003c.04.057.086.107.138.149l.002.001A.71.71 0 00.698 20h5.74a.714.714 0 100-1.429H2.439l4.493-4.494a.713.713 0 00-.498-1.225h-.021.001a.713.713 0 00-.49.216l-4.495 4.494V13.563a.715.715 0 00-.714-.714h-.01v.002z","fill":"#BF9C5F","fill-rule":"nonzero"}})])
          )
        }
      }
    